export const SELLER_TAB = {
    SHOP: Symbol('SHOP'),
    LIKE: Symbol('LIKE'),
    REVIEW: Symbol('REVIEW')
};
